import Conf from '../../configuration'

export default {

    help: function () {

        mailTo(Conf.email.contact)

    }
}

/** private **/

function mailTo(url) {

    window.location.href = 'mailto:' + url

}
